import { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import DashboardContext from "Context";
import InputControl from "components/inputs/InputControl";
import InputControlAsyncMultiBulk from "components/inputs/InputControlAsyncMultiBulk";
import Axios from "axios"
import { Divider } from "antd";
import toaster from "helper/toaster";

export default function BlacklistCustomer() {

    const { handelFromTabel, urldashboard, authentication, handelerrors, setOnSearchLoading, setOffSearchLoding, searchLoading } = useContext(DashboardContext)
    const [workerIds, setWorkerIds] = useState([]);
    const [companyBlackList, setCompanyBlackList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dataFrom, setDataFrom] = useState({ userId: JSON.parse(sessionStorage.getItem('customerid')) })
    const [formData, setFormData] = useState({ userId: JSON.parse(sessionStorage.getItem('customerid')) })

    useEffect(() => {
        handelFromTabel({ userId: JSON.parse(sessionStorage.getItem('customerid')) });
        fetchBlacklistOfCompany();
        return () => { };
    }, []);

    const fetchBlacklistOfCompany = async () => {
        try {
            const res = await Axios.get(`${urldashboard}/karlineCustomerProfile/getCompanyBlacklistWorkers/${dataFrom.userId}`, {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            })
            const data = await res.data.data;
            setCompanyBlackList(data);
        } catch (error) {
            handelerrors(error);
        }
    };

    const handleSubmitCompany = async (event) => {
        event.preventDefault();

        var command = {
            blackListWorkerIds: formData?.blackListWorkerIds !== undefined ? formData?.blackListWorkerIds : companyBlackList?.map(x => x?.value),
            userId: formData?.userId
        };

        setLoading(true);
        try {
            const res = await Axios.post(`${urldashboard}/karlineCustomerProfile/setCompanyBlacklistWorkers`, JSON.stringify(command), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            });
            setLoading(false);
            toaster.success(res?.data?.message);
        } catch (error) {
            handelerrors(error);
            setLoading(false);
        }
        handelFromTabel(command);
    };

    // address

    const fetchBlacklistFromAddress = async (addressId) => {
        try {
            const res = await Axios.get(`${urldashboard}/karlineCustomerProfile/getBlackListWorkers/${dataFrom.userId}/${addressId}`, {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            })
            const data = await res.data.data;
            setWorkerIds(data);
        } catch (error) {
            handelerrors(error);
        }
    };

    const handleValue = (name, value) => {
        switch (name) {
            case "addressId":
                fetchBlacklistFromAddress(value);
                setWorkerIds([]);
                setDataFrom({ ...dataFrom, addressId: value });
                break;
            case "blackListWorkerIds":
                if (value.length === 0) {
                    setWorkerIds([]);
                }
                setDataFrom({ ...dataFrom, blackListWorkerIds: value })
                break;
            default:
                break;
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setOnSearchLoading();
        var dataForm = {
            blackListWorkerIds: dataFrom.blackListWorkerIds !== undefined ? dataFrom.blackListWorkerIds : workerIds.map(x => x.value),
            addressId: dataFrom.addressId,
            userId: dataFrom.userId
        };
        try {
            const res = await Axios.post(`${urldashboard}/karlineCustomerProfile/SetBlackListWorkers`, JSON.stringify(dataForm), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            });
            setOffSearchLoding();
            toaster.success(res?.data?.message);
        } catch (error) {
            handelerrors(error);
        }
        handelFromTabel(dataFrom)
    };

    return (
        <>
            <Form>
                <Form.Row>
                    <Divider>{'برای کل شرکت'}</Divider>
                    <Col>
                        <InputControlAsyncMultiBulk
                            url='/worker/bulksearch'
                            label='لیست نیروها'
                            name='blackListWorkerIds'
                            isDefaultValue={true}
                            idSelect={companyBlackList}
                            handelValue={(_, value) => {
                                value !== null && value !== undefined && value?.length > 0 ?
                                    setFormData({ ...formData, blackListWorkerIds: value }) : setCompanyBlackList([]);
                            }}
                            defaultValue={companyBlackList}
                        />
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Col className='d-flex'>
                        <Button onClick={handleSubmitCompany} variant='success'>
                            {loading ? <i className="fa fa-spinner fa-pulse fa-fw"></i> : "ذخیره"}
                        </Button>
                    </Col>
                </Form.Row>
            </Form>
            <Form>
                <Form.Row>
                    <Divider>{'بر اساس آدرس'}</Divider>
                    <Col lg='6' md='3' sm='12' xs='12' >
                        <InputControl
                            url={`/userManagement/addressdropdown/${JSON.parse(sessionStorage.getItem('customerid'))}`}
                            label='آدرس های مشتری'
                            name='addressId'
                            handelValue={handleValue}
                            defaultValue={0}
                        />
                    </Col>
                    <Col>
                        <InputControlAsyncMultiBulk
                            url='/worker/bulksearch'
                            label='لیست نیروها'
                            name='blackListWorkerIds'
                            isDefaultValue={true}
                            idSelect={workerIds}
                            handelValue={handleValue}
                            defaultValue={workerIds}
                        />
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Col className='d-flex'>
                        <Button onClick={handleSubmit} variant='success'>
                            {searchLoading ? <i className="fa fa-spinner fa-pulse fa-fw"></i> : "ذخیره"}
                        </Button>
                    </Col>
                </Form.Row>
            </Form>
        </>
    )
}
